import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import "../Components/Home/Home.css";

const Home = () => {
  const navigate = useNavigate();
  const { user, isAuth } = useSelector((state) => state.user);

  useEffect(() => {
    if (isAuth && user && user.preferences) {
      const textSize = user.preferences.textSize;

      switch (textSize) {
        case 0: // Small
            document.documentElement.style.setProperty('--font-size-header', '1.5vw');
            document.documentElement.style.setProperty('--font-size-label', '14px');
            document.documentElement.style.setProperty('--font-size-input', '14px');
            document.documentElement.style.setProperty('--font-size-button', '0.8vw');
            break;
        case 1: // Medium (default)
            document.documentElement.style.setProperty('--font-size-header', '2vw');
            document.documentElement.style.setProperty('--font-size-label', '16px');
            document.documentElement.style.setProperty('--font-size-input', '16px');
            document.documentElement.style.setProperty('--font-size-button', '1vw');
            break;
        case 2: // Large
            document.documentElement.style.setProperty('--font-size-header', '3vw');
            document.documentElement.style.setProperty('--font-size-label', '24px');
            document.documentElement.style.setProperty('--font-size-input', '24px');
            document.documentElement.style.setProperty('--font-size-button', '2vw');
            break;
        default:
          break;
      }
    } else if (!isAuth) {
      document.documentElement.style.setProperty('--font-size-header', '2vw');
      document.documentElement.style.setProperty('--font-size-label', '16px');
      document.documentElement.style.setProperty('--font-size-input', '16px');
      document.documentElement.style.setProperty('--font-size-button', '1vw');
    }
  }, [user, isAuth]);

  const handleAccountSettingsClick = () => {
    navigate('/upload');
  };

  return (
    <div className="container">
      <div className="homepage-header1">Welcome to LegalLens</div>
      <div className="homepage-header2">your personal contract analyzer!</div>
      <div className="container2c">
        <div className="homepage-header3">
          Analyze your contracts and terms & conditions agreements effortlessly with our cutting-edge tool. <br />
          Identify suspicious clauses, uncover hidden risks, and receive comprehensive ratings in seconds.
        </div>
        <button className="homepage-upload-button" onClick={handleAccountSettingsClick}>
          Upload and Analyze Document
        </button>
      </div>
    </div>
  );
};

export default Home;
